import { TRUSTPILOT_REVIEW_URL } from '../../AppConstants';

export default function TrustpilotRating({
  className = '',
  linkClassName = 'sb-blue-500 txt-underline',
  inline = false,
}) {
  return (
    <div className={className + ' gMedium'}>
      <a
        href={TRUSTPILOT_REVIEW_URL}
        target='_blank'
        rel='noopener noreferrer'
        className={linkClassName + ' display-inline-block'}
      >
        Read our reviews on Trustpilot
      </a>
    </div>
  );
}
